"use client";
import { getFontSize, getRadius, getSize } from "../../../core/utils/get-size/get-size.mjs";
import { createVarsResolver } from "../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../../core/styles-api/use-styles/use-styles.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import ActionIcon_module_default from "../ActionIcon.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIconGroupSection/ActionIconGroupSection.tsx
const varsResolver = createVarsResolver((theme, { radius, color, gradient, variant, autoContrast, size }) => {
	const colors = theme.variantColorResolver({
		color: color || theme.primaryColor,
		theme,
		gradient,
		variant: variant || "filled",
		autoContrast
	});
	return { groupSection: {
		"--section-height": getSize(size, "section-height"),
		"--section-padding-x": getSize(size, "section-padding-x"),
		"--section-fz": getFontSize(size),
		"--section-radius": radius === void 0 ? void 0 : getRadius(radius),
		"--section-bg": color || variant ? colors.background : void 0,
		"--section-color": colors.color,
		"--section-bd": color || variant ? colors.border : void 0
	} };
});
const ActionIconGroupSection = factory((_props) => {
	const props = useProps("ActionIconGroupSection", null, _props);
	const { className, style, classNames, styles, unstyled, vars, variant, gradient, radius, autoContrast, attributes, ...others } = props;
	return /* @__PURE__ */ jsx(Box, {
		...useStyles({
			name: "ActionIconGroupSection",
			props,
			classes: ActionIcon_module_default,
			className,
			style,
			classNames,
			styles,
			unstyled,
			attributes,
			vars,
			varsResolver,
			rootSelector: "groupSection"
		})("groupSection"),
		variant,
		...others
	});
});
ActionIconGroupSection.classes = ActionIcon_module_default;
ActionIconGroupSection.varsResolver = varsResolver;
ActionIconGroupSection.displayName = "@mantine/core/ActionIconGroupSection";
//#endregion
export { ActionIconGroupSection };

//# sourceMappingURL=ActionIconGroupSection.mjs.map